/* eslint-disable */
/**
 * SPA
 * API serving data for the SPA
 *
 * The version of the OpenAPI document is present in runtime.ts
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Incident
 */
export interface Incident {
    /**
     * e.g. INCIDENT-2020-12-17_11:32:58
     * @type {string}
     * @memberof Incident
     */
    incidentId: string;
}

/**
 * Check if a given object implements the Incident interface.
 */
export function instanceOfIncident(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "incidentId" in value;

    return isInstance;
}

export function IncidentFromJSON(json: any): Incident {
    return IncidentFromJSONTyped(json, false);
}

export function IncidentFromJSONTyped(json: any, ignoreDiscriminator: boolean): Incident {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'incidentId': json['incidentId'],
    };
}

export function IncidentToJSON(value?: Incident | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'incidentId': value.incidentId,
    };
}

